<div class="content-section mb-12">
  <ng-container [ngSwitch]="question.type">
    <app-disable-single *ngSwitchCase="'single'" [question]="question"></app-disable-single>
    <app-disable-multiple-choice
      *ngSwitchCase="'multiple-choice'"
      [question]="question"
    ></app-disable-multiple-choice>
    <app-disable-agree-disagree
      *ngSwitchCase="'agree-disagree'"
      [question]="question"
    ></app-disable-agree-disagree>
    <app-disable-poor-excellent
      *ngSwitchCase="'poor-excellent'"
      [question]="question"
    ></app-disable-poor-excellent>
    <app-disable-never-always
      *ngSwitchCase="'never-always'"
      [question]="question"
    ></app-disable-never-always>
    <app-disable-semantic-ability
      *ngSwitchCase="'semantic-ability'"
      [question]="question"
    ></app-disable-semantic-ability>
    <app-disable-semantic-neutral
      *ngSwitchCase="'semantic-neutral'"
      [question]="question"
    ></app-disable-semantic-neutral>
    <app-disable-poor-outstanding
      *ngSwitchCase="'poor-outstanding'"
      [question]="question"
    ></app-disable-poor-outstanding>
    <app-disable-novice-expert
      *ngSwitchCase="'novice-expert'"
      [question]="question"
    ></app-disable-novice-expert>
    <app-disable-likert-scale-1
      *ngSwitchCase="'likert-scale-1'"
      [question]="question"
    ></app-disable-likert-scale-1>
    <app-disable-likert-scale-2
      *ngSwitchCase="'likert-scale-2'"
      [question]="question"
    ></app-disable-likert-scale-2>
    <app-disable-likert-scale-3
      *ngSwitchCase="'likert-scale-3'"
      [question]="question"
    ></app-disable-likert-scale-3>
    <app-disable-multiple-select
      *ngSwitchCase="'multiple-select'"
      [question]="question"
    ></app-disable-multiple-select>
    <app-disable-choice-with-opinion
      *ngSwitchCase="'choice-with-opinion'"
      [question]="question"
    ></app-disable-choice-with-opinion>
    <app-disable-semantic-yes
      *ngSwitchCase="'semantic-yes'"
      [question]="question"
    ></app-disable-semantic-yes>
    <app-disable-semantic-high
      *ngSwitchCase="'semantic-high'"
      [question]="question"
    ></app-disable-semantic-high>
    <app-disable-parent *ngSwitchCase="'parent'" [question]="question"></app-disable-parent>
  </ng-container>
</div>
